import React, { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";
import ReactMarkdown from "react-markdown";

const TypingText = ({
  text,
  typingDelay = 10,
  onCallbackFinish = () => {},
  sx = {},
}) => {
  const [introArray, setIntroArray] = useState([]);
  const [autoScrollIsActive, setAutoScrollIsActive] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const starterArray = text?.split("\n");

    setIntroArray([]);

    const createTypingEffect = async (text, index) => {
      const typeCharacter = (char, i) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            setIntroArray((prevArray) => {
              const newArray = [...prevArray];
              newArray[index] += char;
              return newArray;
            });
            resolve();
          }, typingDelay * i);
        });
      };

      const typingPromises = text.split("").map(typeCharacter);
      return Promise.all(typingPromises);
    };

    const cycleThroughLines = async () => {
      for (let i = 0; i < starterArray.length; i++) {
        setIntroArray((prevArray) => [...prevArray, ""]);
        await createTypingEffect(starterArray[i], i);
      }

      onCallbackFinish();
    };

    cycleThroughLines();
    // eslint-disable-next-line
  }, [text, typingDelay]);

  useEffect(() => {
    if (containerRef.current && autoScrollIsActive) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [introArray, autoScrollIsActive]);

  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      // Disable auto-scroll if the user scrolls up
      if (scrollTop + clientHeight >= scrollHeight) {
        setAutoScrollIsActive(true); // Reactivate auto-scroll
      } else {
        setAutoScrollIsActive(false); // Disable auto-scroll when scrolling up
      }
    }
  };

  const handleUserInteraction = () => {
    setAutoScrollIsActive(false);
  };
  return (
    <Typography
      component="div"
      variant="body2"
      onScroll={handleScroll}
      onMouseDown={handleUserInteraction}
      onTouchStart={handleUserInteraction}
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        ...sx,
      }}
    >
      {introArray.map((introLine, index) => (
        <ReactMarkdown key={index}>{introLine}</ReactMarkdown>
      ))}
    </Typography>
  );
};

export default TypingText;
